import {useEffect, useState} from 'react';
import { Button, ButtonProps } from 'react-bootstrap';
import CheckInfoDialog from './components/CheckInfoDialog';

type Props = ButtonProps & {
	label?: string;
	patientInfo?: any;
	onUpdatePatientInfoFromInsurance?: (patientData: any, isLookedUp?: boolean) => void;
};

const CheckInsuranceButton = ({
	label = 'Kiểm tra thẻ BHYT',
	patientInfo,
	onUpdatePatientInfoFromInsurance,
	...props
}: Props) => {
	const [openCheckDialog, setOpenCheckDialog] = useState(false);
  useEffect(() => {
    const checkBtn = document.getElementById("check-insurance-btn");
    if (!openCheckDialog && document.activeElement === checkBtn) {
      (document.activeElement as HTMLElement).blur(); // prevent open dialog when scan qr
    }
  }, [openCheckDialog]);
	return (
		<>
			<Button
        id="check-insurance-btn"
				className="btn-fill spaces ml-4"
				{...props}
				onClick={() => setOpenCheckDialog(true)}
			>
				<img src="media/images/verify.png" alt="" className='spaces W-18 h-18 mr-5'/>
				{label}
			</Button>

			{openCheckDialog && (
				<CheckInfoDialog
					open={openCheckDialog}
					onClose={() => setOpenCheckDialog(false)}
					patientInfo={patientInfo}
					onUpdatePatientDataFromInsurance={(data: any, isLookedUp: boolean = false) => {
						onUpdatePatientInfoFromInsurance?.(data, isLookedUp);
						setOpenCheckDialog(false);
					}}
				/>
			)}
		</>
	);
};

export default CheckInsuranceButton;
